<template>
  <div>
    <p
      v-if="selectPaymentMethod && !isShowKPayment && !isTransferToBankAccount"
      class="text-center error--text text-h4 my-16">
      Coming Soon
    </p>
    <template v-if="isPayViaCreditCard">
      <base-payment-credit-card
        v-if="!isOrderResultEmpty"
        :order-result="orderResult"
      />
    </template>
    <template v-if="isTransferToBankAccount">
      <v-card
        outlined
        tile
        elevation="0"
        class="pa-10"
      >
        <div class="_fs-24">
          โอน/ชำระผ่านบัญชีธนาคาร
        </div>
        <div class="px-0 px-md-16">
          <base-payment-upload-card />
        </div>
      </v-card>
      <div
        v-if="!isSlipPage"
        class="d-flex justify-center">
        <v-btn
          class="my-8"
          color="primary"
          rounded
          min-width="200"
          exact
          :to="{ name: 'UploadSlipByOrderId', params: { orderId: orderResult._id } }"
        >
          แจ้งหลักฐานชำระเงิน
        </v-btn>
      </div>
    </template>
    <template v-if="isPayViaQRCode">
      <base-payment-q-r-code
        v-if="!isOrderResultEmpty"
        :order-result="orderResult"
      />
    </template>
  </div>
</template>
<script>
export default {
  components: {
    BasePaymentUploadCard: () => import('@/components/Order/BasePaymentUploadCard'),
    BasePaymentCreditCard: () => import('@/components/Order/BasePaymentCreditCard.vue'),
    BasePaymentQRCode: () => import('@/components/Order/BasePaymentQRCode.vue')
  },
  props: {
    selectPaymentMethod: {
      type: String,
      default: ''
    },
    orderResult: {
      type: Object,
      default: undefined
    }
  },
  computed: {
    isShowKPayment() {
      return true
    },
    isSlipPage() {
      return this.$route.name === 'UploadSlipByOrderId'
    },
    isPayViaCreditCard() {
      return this.isShowKPayment && this.$props.selectPaymentMethod === 'byCreditCard'
    },
    isTransferToBankAccount() {
      return this.$props.selectPaymentMethod === 'transfer'
    },
    isPayViaQRCode() {
      return this.isShowKPayment && this.$props.selectPaymentMethod === 'qrCode'
    },
    isOrderResultEmpty() {
      if (!this.orderResult) {
        return true
      }

      return Object.values(this.orderResult).length === 0
    }
  }
}
</script>
<style lang="scss">
.SelectMethodTransaction {
  .v-input--radio-group__input {
    width: 100%;
    justify-content: space-between;
  }
}
</style>
